/**
 * La plateforme servie par ce déploiement.
 *
 * Elle est passée par un contexte et non par une propriété, parce qu'elle n'est
 * pas une caractéristique d'un écran : c'est une caractéristique du service.
 * Test et production sont deux déploiements distincts, chacun avec ses comptes
 * et ses clés — aucun écran ne peut la changer, tous ont le droit de la lire.
 */
import { createContext, useContext, type ReactNode } from 'react';
import type { Plateforme } from '../api/client';

const PLATEFORME_PAR_DEFAUT: Plateforme = {
  mode: 'test',
  signup_enabled: true,
  key_prefix: 'ik_test_',
};

const ContextePlateforme = createContext<Plateforme>(PLATEFORME_PAR_DEFAUT);

export function FournirPlateforme({
  valeur,
  children,
}: {
  valeur: Plateforme;
  children: ReactNode;
}) {
  return <ContextePlateforme.Provider value={valeur}>{children}</ContextePlateforme.Provider>;
}

export function usePlateforme(): Plateforme {
  return useContext(ContextePlateforme);
}

/**
 * Raccourci de lecture. Le défaut est `test` : un écran monté hors contexte
 * affichera les garde-fous du bac à sable plutôt que de laisser croire à une
 * production. Se tromper dans ce sens-là ne coûte rien.
 */
export function useEstProduction(): boolean {
  return usePlateforme().mode === 'production';
}
